import { Spinner } from "react-bootstrap"

export default function InsumosBtnLoading({ btnId, btnIdClick, loading }: iProps) {

    if (!loading) {
        return (
            <span></span>
        )
    }

    if (btnIdClick !== btnId) {
        return (
            <span></span>
        )
    }
    
    return (
        <Spinner size="sm" />
    )
}
interface iProps {
    btnId: string
    btnIdClick: string
    loading: boolean
}
